'use strict';
import angular from 'angular';
import $ from 'jquery';

import addStepsHtmlUrl from '../views/addSteps.html';
import addGroupHtmlUrl from '../views/addGroup.html';
import addStepToGroupHtmlUrl from '../views/addStepToGroup.html';

angular.module('steps.ctrls', [])

    .controller('StepAddEditController', ['$rootScope', '$scope', '$modalInstance', 'step', 'StepsService', 'ClusterService', 'UserService', '$ioAlert', function($rs, $scope, $modalInstance, step, StepsService, ClusterService, UserService, $ioAlert) {

        $scope.stepsObj = {
            "defaultColor": "#1818bd"
        };

        if (step) {
            $scope.titleText = "Update Step";
            $scope.stepsObj = {
                "name": step.name,
                "defaultColor": step.default_color,
                "description": step.description
            };

            $scope.stepsObj.active = (step.active == '1');
        } else {
            $scope.titleText = "Add Step";
        }

        $scope.addStep = function(stepsForm) {
            if (stepsForm.$valid) {
                if ($scope.stepsObj) {
                    var stepObj = JSON.parse(JSON.stringify($scope.stepsObj));
                    if (stepObj.active) {
                        stepObj.active = 1;
                    } else {
                        stepObj.active = 0;
                    }
                    if (step) {
                        stepObj.id = step.id;
                        StepsService.updateStep(stepObj).then(function(response) {

                            if (response.errors && response.errors.length < 0) {

                                var errorMessage = "";
                                for (var i = 0; i < response.errors.length; i++) {
                                    errorMessage += response.errors[i] + ". ";
                                }
                                $ioAlert.show('ERROR!', errorMessage, 'error');

                            } else {
                                $modalInstance.close(response.workflowStep);
                            }
                        }, function(error) {
                            console.log("Error Adding Step");
                        });
                    } else {
                        StepsService.addStep(stepObj).then(function(response) {
                            $modalInstance.close();
                        }, function(error) {
                            $ioAlert.show('ERROR!', 'Adding step failed. Please try again later.', 'error');
                        });
                    }
                }
            }
        };

        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        ClusterService.initCluster($rs.userRole, 'hidden');
    }])

    .controller('StepsController', ['$rootScope', '$scope', 'StepsService', 'UserService', '$modal', '$ioAlert', '$confirm', 'ClusterService', function($rs, $scope, StepsService, UserService, $modal, $ioAlert, $confirm, ClusterService) {

        $scope.steps = [];

        var addEditStep = function(step) {
            var isNew = true;
            if (step) {
                isNew = false;
            }
            $modal.open({
                controller: 'StepAddEditController',
                templateUrl: addStepsHtmlUrl,
                resolve: {
                    step: function() {
                        return step;
                    }
                },
                backdrop: 'static'
            }).result.then(function(obj) {
                if (isNew) {
                    getSteps();
                    $ioAlert.show('Step Added', 'Step has been added successfully', 'success');
                } else {

                    for (var i = 0, len = $scope.steps.workflowSteps.length; i < len; i++) {
                        if (obj.id == $scope.steps.workflowSteps[i].id) {
                            $scope.steps.workflowSteps[i] = obj;
                            break;
                        }
                    }
                    $ioAlert.show('Step updated', 'Step has been updated successfully', 'success');
                }
            }, function(cancel) {
                //Do Nothing
            })
        };

        $scope.addStep = function() {
            addEditStep();
        };

        $scope.editStep = function(index) {
            addEditStep($scope.steps.workflowSteps[index]);
        };

        $scope.removeStep = function(index) {
            var step = $scope.steps.workflowSteps[index];
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this Step Group?'
            }).then(function() {
                StepsService.removeStep({
                    id: step.id
                }).then(function(response) {
                    if (response.errors && response.errors.length > 0) {
                        for (var i = 0, len = response.errors.length; i < len; i++) {
                            $ioAlert.show('ERROR!', response.errors[i], 'error');
                        }
                    } else {
                        $ioAlert.show('Step deleted', 'Step has been deleted successfully', 'success');
                        $scope.steps.workflowSteps.splice(index, 1);
                    }
                });
            });
        };

        var getSteps = function() {
            StepsService.getSteps().then(function(success) {
                $scope.steps = success[0];
                //console.log($scope.steps);
            }, function(error) {
                //TODO - Identify Error Action
                $ioAlert.show('Error!', 'Could not retrieve steps.', 'error');
            });
        };

        var init = function() {
            ClusterService.initCluster($rs.userRole, 'hidden');

            // GET ALL STEPS
            getSteps();
        };

        init();
    }])
    .controller('StepGroupsAddEditController', ['$rootScope', '$scope', '$modalInstance', 'group', 'StepGroupService', 'ClusterService', function($rs, $scope, $modalInstance, group, StepGroupService, ClusterService) {

        $scope.groupObj = {};
        $scope.selectedIcon = {};

        $scope.iconsList = [{
            "id": "fa fa-bars",
            "name": "bars"
        }, {
            "id": "fa fa-arrows",
            "name": "arrows"
        }, {
            "id": "fa fa-rss",
            "name": "feed"
        }, {
            "id": "fa fa-arrows-h",
            "name": "Arrows Horizontal"
        }, {
            "id": "fa fa-arrows-v",
            "name": "Arrows Vertical"
        }, {
            "id": "fa fa-paperclip",
            "name": "Paperclip"
        }, {
            "id": "fa fa-file",
            "name": "File"
        }, {
            "id": "fa fa-link",
            "name": "Link"
        }, {
            "id": "fa fa-scissors",
            "name": "scissors"
        }];

        if (group) {
            $scope.groupObj = {
                "name": group.name,
                "description": group.description,
                "icon": group.icon
            };
            for (var i = 0, len = $scope.iconsList.length; i < len; i++) {
                if ($scope.iconsList[i].id == group.icon) {
                    $scope.selectedIcon = $scope.iconsList[i];
                }
            }

            $scope.groupObj.active = (group.active == '1');
            $scope.titleText = "Update Step Policy";
        } else {
            $scope.titleText = "Add Step Policy";
        }

        if (Object.keys($scope.selectedIcon).length == 0) {
            $scope.selectedIcon = $scope.iconsList[0];
            $scope.groupObj.icon = $scope.iconsList[0].id;
        }

        $scope.setIcon = function(icon) {
            $scope.groupObj.icon = icon.id;
            $scope.selectedIcon = icon;
        };

        $scope.addGroup = function(stepsForm) {
            if (stepsForm.$valid) {
                if ($scope.groupObj) {
                    var groupObj = JSON.parse(JSON.stringify($scope.groupObj));
                    if (groupObj.active) {
                        groupObj.active = 1;
                    } else {
                        groupObj.active = 0;
                    }
                    if (group) {
                        groupObj.id = group.id;
                        StepGroupService.updateStepGroup(groupObj).then(function(response) {
                            $modalInstance.close(response.workflowStepGroup);
                        }, function(error) {
                            console.log("Error Updating Step");
                        });
                    } else {
                        StepGroupService.addStepGroup(groupObj).then(function(response) {
                            $modalInstance.close(response.workflowStepGroup);
                        })
                    }
                }
            }
        };

        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        ClusterService.initCluster($rs.userRole, 'hidden');
    }])
    .controller('StepGroupsController', ['$rootScope', '$scope', '$modal', 'StepsService', 'UserService', 'StepGroupService', '$ioAlert', '$confirm', '$state', 'ClusterService', 'FormService', function($rs, $scope, $modal, StepsService, UserService, StepGroupService, $ioAlert, $confirm, $state, ClusterService, FormService) {
        $scope.stepGroups = [];
        var clickedId;
        $scope.disableBtnAction = false;

        var getGroups = function() {
            $rs.loadingInProgress = true;
            $rs.loadertitle = "Fetching workflow Step Policy";
            StepGroupService.getStepGroups().then(function(response) {
                $scope.stepGroups = response[0];
                for (var i = 0, len = $scope.stepGroups.workflowStepGroups.length; i < len; i++) {
                    $scope.stepGroups.workflowStepGroups[i].sortableOptions = {
                        "disabled": true
                    }
                }
                $rs.loadingInProgress = false;
            }, function(error) {
                console.log("Error getting steps");
                $rs.loadingInProgress = false;
            });
        };

        var getSteps = function() {
            StepsService.getSteps().then(function(success) {
                $scope.steps = success[0].workflowSteps;
            }, function(error) {
                //TODO - Identify Error Action
                $ioAlert.show('Error!', 'Could not retrieve steps.', 'error');
            });
        };

        $scope.addEditStepGroup = function(group) {
            var isNewGroup = true;
            if (group) {
                isNewGroup = false;
            }
            $modal.open({
                controller: 'StepGroupsAddEditController',
                templateUrl: addGroupHtmlUrl,
                resolve: {
                    group: function() {
                        return group;
                    }
                },
                backdrop: 'static'
            }).result.then(function(obj) {
                obj.sortableOptions = {
                    "disabled": true
                };
                if (isNewGroup) {
                    $scope.stepGroups.workflowStepGroups.push(obj);
                    $ioAlert.show('Step Group Added', 'Step Group has been added successfully', 'success');
                } else {
                    for (var i = 0, len = $scope.stepGroups.workflowStepGroups.length; i < len; i++) {
                        if (obj.id == $scope.stepGroups.workflowStepGroups[i].id) {
                            $scope.stepGroups.workflowStepGroups[i] = obj;
                            break;
                        }
                    }
                    $ioAlert.show('Step Group updated', 'Step Group has been updated successfully', 'success');
                }
            }, function(cancel) {})
        };

        $scope.deleteStepGroup = function(group) {
            $confirm.open({
                size: 'sm',
                text: 'Are you sure you want to delete this Step Group?'
            }).then(function() {
                StepGroupService.deleteStepGroup({
                    'id': group.id
                }).then(function(response) {
                    if (!response.errors) {
                        var index = $scope.stepGroups.workflowStepGroups.indexOf(group);
                        $scope.stepGroups.workflowStepGroups.splice(index, 1);
                        $ioAlert.show('Step Group deleted', 'Step Group has been successfully deleted', 'success');
                    } else {
                        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                    }
                }, function(error) {
                    console.log("error deleting TapIO Step Group");
                    $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
                });
            }, function() {})
        };

        $scope.addStepsToGroup = function(group) {
            $modal.open({
                controller: 'AddStepToGroupController',
                templateUrl: addStepToGroupHtmlUrl,
                resolve: {
                    group: function() {
                        return group;
                    },
                    steps: function() {
                        return $scope.steps;
                    }
                },
                backdrop: 'static'
            }).result.then(function(arr) {
                group.steps = arr;
                $ioAlert.show('Steps Added', 'Steps added to group successfully', 'success');
            }, function(cancel) {})
        };

        $scope.updateOrdering = function(group) {
            var promises = [];
            for (var i = 0, len = group.steps.length; i < len; i++) {
                promises.push({
                    "workflowStepId": group.steps[i].workflow_step_id,
                    "sequence": i + 1,
                    "color": group.steps[i].color
                })
            }

            var obj = {
                "workflowStepGroupId": group.id,
                "workflowStepGroupXrefs": promises
            };

            StepGroupService.addStepToGroup(obj).then(function(response) {
                $ioAlert.show('Steps Order Updated', 'Steps order updated successfully', 'success');
                group.sortableOptions.disabled = true;
                group.showDragDrop = false;
            }, function(error) {});
        };

        $scope.cancelOrdering = function(group) {
            group.sortableOptions.disabled = true;
            group.showDragDrop = false;
        };

        $scope.editStepsToGroup = function(group) {
            group.sortableOptions.disabled = false;
            group.showDragDrop = true;
        };

        $scope.getStepsForGroups = function(ev, group) {
            //Toggle The Chevron
            var chevron = $(ev.currentTarget).children('span');
            if ($(ev.currentTarget).children('span').attr('class').indexOf('fa-chevron-right') > 0) {
                $(ev.currentTarget).children('span').removeClass('fa-chevron-right');
                $(ev.currentTarget).children('span').addClass('fa-chevron-down');
                group.steps = [];
                StepGroupService.getStepsXrefs({
                    'workflowStepGroupId': group.id
                }).then(function(response) {
                    group.show = true;
                    group.steps = response.workflowStepGroupXrefs;
                }, function(error) {

                })
            } else {
                group.show = false;
                group.sortableOptions.disabled = true;
                group.showDragDrop = false;
                $(ev.currentTarget).children('span').removeClass('fa-chevron-down');
                $(ev.currentTarget).children('span').addClass('fa-chevron-right');
            }
        };

        $scope.goToPage = function(page) {
            $state.go(page);
        };

        /*
        * Handle get instance lock configuration
        */
        var getInstanceLockConfig = function() {
            FormService.getInstanceLockConfig().then(function(data) {
                if(data.instanceLocked) {
                    $scope.disableBtnAction = true;
                } else {
                    $scope.disableBtnAction = false;
                }

            }, function(error) {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }
        UserService.adjustStickyHeaderWindowResize();
        var init = function() {
            ClusterService.initCluster($rs.userRole, 'hidden');

            getGroups();
            getSteps();
            getInstanceLockConfig();
            UserService.adjustStickyHeader();
        };

        init();
    }])
    .controller('AddStepToGroupController', ['$rootScope', '$scope', '$modalInstance', '$ioAlert', 'group', 'steps', 'StepGroupService', 'ClusterService', 'StepsService', function($rs, $scope, $modalInstance, $ioAlert, group, steps, StepGroupService, ClusterService, StepsService) {

        $scope.availableSteps = [];
        $scope.steps = steps;
        $scope.stepsObj = {
            'defaultColor': "#1818bd"
        };

        if (!group.steps) {
            group.steps = [];
        }

        let bIds = {};
        group.steps.forEach(function(obj) {
            bIds[obj.workflow_step_id] = obj;
        });

        // Return all elements in A, unless in B
        $scope.availableSteps = $scope.steps.filter(function(obj) {
            return !(obj.id in bIds);
        });

        for (let i = group.steps.length - 1; i >= 0; i--) {
            $scope.availableSteps.unshift({
                'id': group.steps[i].workflow_step_id,
                'default_color': group.steps[i].color,
                'name': group.steps[i].name,
                'description': group.steps[i].description,
                'workflow_names': group.steps[i].workflow_names,
                'checked': true,
            })
        }

        $scope.addStep = function(stepsForm) {
            let promises = [];
            let sequence = 1;
            for (let i = 0, len = $scope.availableSteps.length; i < len; i++) {
                if ($scope.availableSteps[i].checked) {
                    promises.push({
                        'workflowStepId': $scope.availableSteps[i].id,
                        'sequence': sequence++,
                        'color': $scope.availableSteps[i].default_color
                    });
                }
            }

            let obj = {
                'workflowStepGroupId': group.id,
                'workflowStepGroupXrefs': promises
            };

            StepGroupService.addStepToGroup(obj).then(function(response) {
                $modalInstance.close(response.workflowStepGroupXrefs);
            }, function(error) {});
        };

        $scope.addNewStep = function(stepsForm) {
            if (stepsForm.$valid) {
                if ($scope.stepsObj) {
                    let stepObj = JSON.parse(JSON.stringify($scope.stepsObj));
                    if (stepObj.active) {
                        stepObj.active = 1;
                    } else {
                        stepObj.active = 0;
                    }
                    StepsService.addStep(stepObj).then(function(response) {
                        response.workflowStep.checked = false;
                        $scope.availableSteps.push(response.workflowStep);
                    }, function(error) {
                        $ioAlert.show('ERROR!', 'Adding step failed. Please try again later.', 'error');
                    });

                }
            }
        };

        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        ClusterService.initCluster($rs.userRole, 'hidden');
    }]);